import React from 'react';
import FormLinksContainer from '../DataEntryForm/layout/FormLinksContainer/FormLinksContainer';
import Buttons from '../DataEntryForm/Buttons/Buttons';
import Disclosures from '../DataEntryForm/Disclosures/Disclosures';
import NonInputsContainer from '../DataEntryForm/layout/NonInputsContainer/NonInputsContainer';
import Inputs from '../DataEntryForm/Inputs/Inputs';
import SecurityLinks from '../DataEntryForm/SecurityLinks/SecurityLinks';
import TermsLink from '../DataEntryForm/TermsLink/TermsLink';
import AlreadyAMember from '../DataEntryForm/AlreadyAMember/AlreadyAMember';
import { AddressValidationStateProvider } from '../../providers/AddressValidationProvider';
import Form_OrangeAsterisk from './Form_OrangeAsterisk';
import DisclaimerText from '../DisclaimerText/DisclaimerText';
import InlinePushup from '../../../../utils/utility-components/InlinePushup';
import usePushupMessages from '../../hooks/usePushupMessages';
import { Row, Col } from '../../../../importCL';
import './OrangeAsteriskVariant.css';

export default function DataEntryFormOrangeAsterisk() {
    return (
        <Row as='section' className='DataEntryForm mt-4'>
            <Col className='!px-10'>
                <AddressValidationStateProvider>
                    <Form_OrangeAsterisk>
                        <Inputs isVersionOrangeVariant />
                        <NonInputsContainer>
                            <Disclosures />
                            <InlinePushup messages={usePushupMessages().messages}/>
                            <Buttons />
                        </NonInputsContainer>
                        <FormLinksContainer>
                            <SecurityLinks />
                            <TermsLink />
                        </FormLinksContainer>
                    </Form_OrangeAsterisk>
                </AddressValidationStateProvider>
                <DisclaimerText/>
                <div className='DataEntryForm__member_button mx-auto'>
                    <AlreadyAMember />
                </div>
            </Col>
        </Row >
    );
} 